/**
 * @generated SignedSource<<fabd200d8431601509dd185e4b928acf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FacilityLogoFragment_club$data = {
  readonly logoImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly " $fragmentType": "FacilityLogoFragment_club";
};
export type FacilityLogoFragment_club$key = {
  readonly " $data"?: FacilityLogoFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FacilityLogoFragment_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "13873fbae602968327a7c319e554a532";

export default node;
